import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { PaymentService } from 'src/app/services/payment/payment.service';
import { PaymentRequest } from './models/PaymentRequest';
import { PromotionService } from 'src/app/services/promotion/promotion.service';

@Component({
  selector: 'app-payment',
  templateUrl: './payment.component.html',
  styleUrls: ['./payment.component.css'],
})
export class PaymentComponent {
  product: any;
  paymentForm: FormGroup;
  promotionDiscount: number = 0;
  price: number = 0;
  paymentRequest: PaymentRequest = {
    amount: 0,
    currency: "EGP",
    payment_methods: [4911226, 4911227],
    items: [],
    billing_data: {
        first_name: "",
        last_name: "",
        phone_number: "",
        email: "",
    },
    customer: {
        first_name: "",
        last_name: "",
        email: ""
    }
  };

  constructor(private fb: FormBuilder, private paymentService: PaymentService, private promotionService: PromotionService, private router: Router, private route: ActivatedRoute) {
    const navigation = this.router.getCurrentNavigation();
    const stateKey = navigation?.extras.state?.['productKey'];

    if (stateKey) {
      this.getProduct(stateKey);
    } else {
      this.route.queryParams.subscribe(params => {
        const queryKey = params['productKey'];

        if (queryKey) {
          this.getProduct(queryKey);
        } else if (localStorage.getItem('testPaymentService') === 'true') {
          this.getProduct('test-service');
        }
      });
    }

    this.paymentForm = this.fb.group({
      firstName: ['', Validators.required],
      lastName: ['', Validators.required],
      phone: ['', [Validators.required, Validators.pattern('^[0-9]*$')]],
      email: ['', [Validators.required, Validators.email]],
      promotion: [''],
    });
  }

  getProduct(productKey: string) {
    this.paymentService.getProduct(productKey).then((product: any) => {
      this.product = product;      
      this.price = product.amount;
      product.quantity = 1;
      product.amount *= 100;
      this.paymentRequest.amount = product.amount;
      this.paymentRequest.items.push(product);
    });
  }

  useCode() {
    if (this.promotionDiscount > 0) return;
    this.promotionService.usePromotionCode(this.paymentForm.value.promotion).subscribe((promotion: any) => {
      this.promotionDiscount = promotion.discountPercentage;
      this.paymentRequest.promotionCode = promotion.code;
      let promotionType = promotion.promotionType;
      
      let discountAmount = promotionType === 'percentage' ? (this.paymentRequest.amount * (this.promotionDiscount / 100)) : this.promotionDiscount;
      if (discountAmount < 0) discountAmount = 0;

      this.paymentRequest.amount -= discountAmount;
      this.paymentRequest.items[0].amount -= discountAmount;
    });
  }

  onSubmit() {
    if (this.paymentForm.valid) {
      let form = this.paymentForm.value;
      this.paymentRequest.billing_data.first_name = form.firstName;
      this.paymentRequest.billing_data.last_name = form.lastName;
      this.paymentRequest.billing_data.email = form.email;
      this.paymentRequest.billing_data.phone_number = form.phone;
      
      this.paymentRequest.customer.first_name = form.firstName;
      this.paymentRequest.customer.last_name = form.lastName;
      this.paymentRequest.customer.email = form.email;

      this.paymentService.sendPaymentRequest(this.paymentRequest).subscribe((paymentLink: any) => {
        localStorage.setItem('redirectProductKey', this.product.key);
        if (paymentLink.replace(" ", "").startsWith('http')) window.open(paymentLink.replace(" ", ""), '_blank');
        else {
          alert(paymentLink);
          this.router.navigate(['/payment-redirect']);
        }
      });
    }
  }
}
